/**
 * Installs app-wide dependencies on globalProperties for Options API components.
 *
 * Prefer named imports in new code:
 *   import api from '@/services/APIDataService'
 *   import { INVOICE_STATUS_DIC } from '@/constants'
 *   import functions from '@/services/Functions'
 *
 * Legacy aliases ($API, $INVOICE_STATUS_DIC, …) are preserved.
 */
import api from '../services/APIDataService'
import functions from '../services/Functions'
import constants from '../constants/definitions'

/**
 * Map of globalProperty name → value.
 * Keep aliases intentional and documented.
 */
const GLOBAL_MAP = {
  // Services / utils
  $API: api,
  $F: functions,
  $constants: constants,

  // Access / people
  $FILE_TYPE: constants.FILE_TYPE,
  $USER_ACCESS_LEVELS: constants.USER_ACCESS_LEVELS,
  $USER_ACCESS_LEVELS_DIC: constants.USER_ACCESS_LEVELS_DIC,
  $USER_STATUSES: constants.USER_STATUSES,
  $USER_STATUSES_DIC: constants.USER_STATUSES_DIC,
  $GROUP_ROLES: constants.G_ROLES,
  $GROUP_ROLES_DIC: constants.G_ROLE_DIC,
  $SUB_GROUP_ROLES: constants.SG_ROLES,
  $SUB_GROUP_ROLES_DIC: constants.SG_ROLE_DIC,
  $LEGAL_PEOPLE_TYPES: constants.LEGAL_PEOPLE_TYPES,
  $LEGAL_PEOPLE_TYPES_DIC: constants.LEGAL_PEOPLE_TYPES_DIC,
  $SPECIAL_FILTERS_LEGAL_PERSON: constants.SPECIAL_FILTERS_LEGAL_PERSON,
  $SPECIAL_FILTERS_NEW_INVOICE: constants.SPECIAL_FILTERS_NEW_INVOICE,
  $SPECIAL_FILTERS_NEW_INVOICE_INTERVALS: constants.SPECIAL_FILTERS_NEW_INVOICE_INTERVALS,

  // Finance
  $CASH_FLOW_CATEGORY_TYPES: constants.CASH_FLOW_CATEGORY_TYPES,
  $CASH_FLOW_CATEGORY_TYPES_DIC: constants.CASH_FLOW_CATEGORY_TYPES_DIC,
  $CASHIER_MOVEMENT_TYPES: constants.CASHIER_MOVEMENT_TYPES,
  $CASHIER_MOVEMENT_TYPES_DIC: constants.CASHIER_MOVEMENT_TYPES_DIC,
  $INVOICE_STATUSES: constants.INVOICE_STATUSES,
  $INVOICE_STATUS_DIC: constants.INVOICE_STATUS_DIC,
  $PAYABLE_INVOICE_STATUSES: constants.PAYABLE_INVOICE_STATUSES,
  $INVOICE_TYPES: constants.INVOICE_TYPES,
  $INVOICE_TYPE_DIC: constants.INVOICE_TYPE_DIC,
  $CHECKOUT_STATUSES: constants.CHECKOUT_STATUSES,
  $CHECKOUT_STATUS_DIC: constants.CHECKOUT_STATUS_DIC,
  $PAYMENT_METHOD_TYPES: constants.PAYMENT_METHOD_TYPES,
  $PAYMENT_METHOD_TYPES_DIC: constants.PAYMENT_METHOD_TYPES_DIC,
  $GROUP_PAYMENT_STATUSES: constants.GROUP_PAYMENT_STATUSES,
  $GROUP_PAYMENT_STATUS_DIC: constants.GROUP_PAYMENT_STATUS_DIC,

  // Events / news
  $EVENT_STATUSES: constants.EVENT_STATUSES,
  $EVENT_STATUS_DIC: constants.EVENT_STATUS_DIC,
  $EVENT_AUTHORIZATION_STATUSES: constants.EVENT_AUTHORIZATION_STATUSES,
  $EVENT_AUTHORIZATION_STATUS_DIC: constants.EVENT_AUTHORIZATION_STATUS_DIC,
  $NEWS_STATUS_DIC: constants.NEWS_STATUS_DIC,
}

export function installGlobals(app) {
  const gp = app.config.globalProperties
  for (const [key, value] of Object.entries(GLOBAL_MAP)) {
    gp[key] = value
  }
}

/** @deprecated use installGlobals */
export function loadGlobalVariables(app) {
  return installGlobals(app)
}
